import React from "react";
import PageTitle from "../../components/Common/MetaTagsHelper/metaTagsHelper";
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import usePageTitle from '../../common/hooks/usePageTitle';

import Dropzone from "react-dropzone";
import Swal from "sweetalert2";

import { getNameClient } from './../../helpers/nameClient';
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { updateFile } from '../../store/LoadFiles/actions';
import { ITable } from "../../components/Common/iComponents/iTable/ITable";


const LoadFile = (props: any)  => {
    const dispatch = useDispatch();
    const { data, message, isLoading } = useSelector((state: any) => state.loadFiles)

    const initialArrayTable = [
        {
            text: 'Part Number',
            dataField: 'PartNumber',
            hidden: false,
        },
        {
            text: 'SKUs',
            dataField: 'SKUs',
            hidden: false,
        },
        {
            text: 'GUIDItem',
            dataField: 'GUIDItem',
            hidden: false,
        },
        {
            text: 'Customer',
            dataField: 'Customer',
            hidden: false,
        },
        {
            text: 'Customer GUIDCL',
            dataField: 'CustomerGUIDCL',
            hidden: false,
        },
        {
            text: 'Inactive',
            dataField: 'Inactive',
            hidden: false,
        }
    ];

    const PageTitleIEN = usePageTitle(props.location.pathname);
    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>Load File | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <Dropzone
                                        multiple={false}
                                        accept={{ "text/csv": [".csv"] }}
                                        onDrop={acceptedFiles => {
                                            if (acceptedFiles.length === 0) {
                                                Swal.fire({ icon: 'error', title: 'You must select a CSV file ' });
                                                return
                                            }
                                            const file = acceptedFiles[0]
                                            dispatch(updateFile(file))
                                        }}
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className="dropzone">
                                                <div
                                                    className="dz-message needsclick mt-2"
                                                    {...getRootProps()}
                                                >
                                                    <input {...getInputProps()} />
                                                    <div className="mb-3">
                                                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                    </div>
                                                    <h4>Drop file here or click to upload.</h4>
                                                    <h6>(CSV only)</h6>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                    <div className="dropzone-previews mt-3" id="file-previews">
                                        {
                                            isLoading ? <div className="d-flex justify-content-center align-items-center"><Spinner></Spinner></div>
                                                :
                                                (data.length > 0 ? (
                                                    <>
                                                        <div className="text-center">{message}</div>
                                                        <ITable
                                                            enableDownload={false}
                                                            valuesSizePagination={[10000]}
                                                            remote={false}
                                                            data={data}
                                                            fields={initialArrayTable}
                                                            tableColumns={initialArrayTable}
                                                            headerColorT={'bg-primary text-white'}
                                                            groupName={""}
                                                            pagSize={4}
                                                            pageStartIn={0}
                                                            showTotal={true}
                                                            disablePageTitle={true}
                                                        />
                                                    </>
                                                ) : <div className="text-center">{message}</div>)
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default LoadFile;